'use client';

import { useEffect } from 'react';
import { useAuthStore } from '@/stores/auth';

/**
 * Triggers Zustand persist rehydration after the first client render.
 *
 * The auth store is configured with `skipHydration: true`, so the initial
 * client render matches the server (empty store) — no React hydration
 * mismatch. This effect then loads the persisted user/memberships from
 * localStorage one tick later, so the previously-signed-in user's
 * info still appears immediately without a network round trip.
 *
 * Mounted at the top of the root layout so it covers every route that
 * reads from the auth store (dashboard, admin, settings, select-dealership,
 * no-dealerships, impersonation banner, etc.). Renders nothing.
 */
export function AuthHydrator() {
  useEffect(() => {
    void useAuthStore.persist.rehydrate();
  }, []);
  return null;
}
